import { render, staticRenderFns } from "./CardPropertiesTsua.vue?vue&type=template&id=ce36ac1e"
import script from "./CardPropertiesTsua.vue?vue&type=script&lang=js"
export * from "./CardPropertiesTsua.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports